import * as React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { AppInstallationDetailsView } from './view';
import { APP_INSTALLATION_QUERY } from 'const/queries';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useParams } from 'react-router-dom';

export function AppInstallationDetails() {
    const { id: appId, iid: installationId } = useParams<{ id: string; iid: string }>();
    const query = {
        id: installationId,
    };
    const { data } = useQuery(APP_INSTALLATION_QUERY, { variables: query });

    if (data && data.installation) {
        return <AppInstallationDetailsView appId={appId} installation={data.installation} />;
    } else {
        return <CircularProgress />;
    }
}
